webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dexie__ = __webpack_require__(32);
//  IndexedDB wrapper for vuejs

//  Instantiate headlines database
var db = new __WEBPACK_IMPORTED_MODULE_0_dexie__["a" /* default */]('headlines');

//  Instantiate indexedDb tables
db.version(1).stores({
  headlinesHome: '++id', //  Auto increment id
  sources: '++id',
  sourcesHeadlines: '',
  countryHeadlines: '',
  favorites: '++id,author,source.name' // auto increment id, index by name
});

/* harmony default export */ __webpack_exports__["a"] = (db);

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NewsAPI = __webpack_require__(26);

var newsapi = new NewsAPI('a346c460a81947d6913e56e30d2ca3b7');

/* harmony default export */ __webpack_exports__["a"] = (newsapi);

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_newsApi__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  NewsApi config file

// instantiate indexedDb


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      allHeadlines: {}
    };
  },

  methods: {
    cleanHeadlinesHome: function cleanHeadlinesHome() {
      var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;

      __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].headlinesHome.reverse().toArray().then(function (val) {
        val.forEach(function (hd, i) {
          if (i > limit) {
            __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].headlinesHome.delete(i);
          }
        });
      });
    },
    addToFavorites: function addToFavorites(headline) {
      __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].favorites.put(headline);
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__assets_js_newsApi__["a" /* default */].v2.topHeadlines({
      country: 'us'
    }).then(function (data) {
      _this.allHeadlines = data.articles;

      var dt = data.articles.map(function (dl) {
        if (dl.source.id === null) {
          dl.source.id = dl.source.name; // eslint-disable-line
        }
        return dl;
      });
      _this.cleanHeadlinesHome();
      //  Store returned data in indexedDb for offline access
      dt.forEach(function (dl) {
        __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].headlinesHome.put(dl);
      });
    }).catch(function () {
      //  If offline, get Data from indexedDb
      __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].headlinesHome.toArray().then(function (val) {
        _this.allHeadlines = val;
      });
    });
  },
  mounted: function mounted() {}
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_newsApi__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//  NewsApi config file

//  Instantiate headlines database


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sources',
  data: function data() {
    return {
      sources: {},
      filterSources: {},
      language: 'en',
      country: 'us',
      searchTerm: ''
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    //  Get NewsApi data
    __WEBPACK_IMPORTED_MODULE_0__assets_js_newsApi__["a" /* default */].v2.sources({
      language: this.language,
      country: this.country
    }).then(function (data) {
      _this.sources = data.sources;
      _this.filterSources = data.sources;
      //  Store data gotten in indexedDb
      data.sources.forEach(function (val) {
        __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].sources.put(val);
      });
    }).catch(function () {
      //  If offline, get Data from indexedDb
      __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].sources.toArray().then(function (val) {
        _this.sources = val;
        _this.filterSources = val;
      });
    });
  },
  mounted: function mounted() {},

  methods: {
    searchThrough: function searchThrough() {
      var searchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (searchTerm === '') this.filterSources = this.sources;
      this.filterSources = this.sources.filter(function (val) {
        return val.name.toLowerCase().includes(searchTerm.toLowerCase());
      });
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_newsApi__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  NewsApi config file

//  Instantiate indexedDb


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sources',
  data: function data() {
    return {
      source: this.$route.params.id,
      country: 'us',
      headlines: {}
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__assets_js_newsApi__["a" /* default */].v2.topHeadlines({
      sources: this.source
    }).then(function (data) {
      _this.headlines = data.articles;
      //  Store the headlines with the source as id
      __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].sourcesHeadlines.put(_this.headlines, _this.source);
    }).catch(function () {
      //  If offline, get Data from indexedDb using the source as id
      __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].sourcesHeadlines.get(_this.source).then(function (val) {
        _this.headlines = val;
      });
    });
  },
  mounted: function mounted() {},

  methods: {
    addToFavorites: function addToFavorites(headline) {
      __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].favorites.put(headline);
    },
    formatDate: function formatDate(date) {
      return new Date(date);
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_newsApi__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_country_json__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_country_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_js_country_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  NewsApi config file

// instantiate indexedDb




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'headlines',
  data: function data() {
    return {
      country: this.$route.params.country,
      countries: __WEBPACK_IMPORTED_MODULE_2__assets_js_country_json___default.a,
      cntry: '',
      headlines: {}
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__assets_js_newsApi__["a" /* default */].v2.topHeadlines({
      country: this.country
    }).then(function (data) {
      _this.headlines = data.articles;
      //  Store returned data in indexedDb for offline access
      __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].countryHeadlines.put(_this.headlines, _this.country);
    }).catch(function () {
      //  If offline, get Data from indexedDb
      __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].countryHeadlines.get(_this.country).then(function (val) {
        _this.allHeadlines = val;
      });
    });
  },
  mounted: function mounted() {},

  methods: {
    addToFavorites: function addToFavorites(headline) {
      __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].favorites.put(headline);
    },
    ctry: function ctry(ct) {
      var _this2 = this;

      this.country = ct;
      __WEBPACK_IMPORTED_MODULE_0__assets_js_newsApi__["a" /* default */].v2.topHeadlines({
        country: this.country
      }).then(function (data) {
        _this2.headlines = data.articles;
        //  Store returned data in indexedDb for offline access
        __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].countryHeadlines.put(_this2.headlines, _this2.country);
      }).catch(function () {
        //  If offline, get Data from indexedDb
        __WEBPACK_IMPORTED_MODULE_1__assets_js_dexie__["a" /* default */].countryHeadlines.get(_this2.country).then(function (val) {
          _this2.allHeadlines = val;
        });
      });
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_dexie__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// instantiate indexedDb


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Favorites',
  data: function data() {
    return {
      headlines: {},
      sort: ''
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__assets_js_dexie__["a" /* default */].favorites.toArray().then(function (val) {
      _this.headlines = val;
    });
  },
  mounted: function mounted() {},

  methods: {
    sortBy: function sortBy(sort) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__assets_js_dexie__["a" /* default */].favorites.orderBy(sort).toArray().then(function (val) {
        _this2.headlines = val;
      });
    }
  }
});

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Nav__ = __webpack_require__(52);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-header',
  components: {
    'app-nav': __WEBPACK_IMPORTED_MODULE_0__Nav__["a" /* default */]
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-nav'
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

var year = new Date().getFullYear();
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-footer',
  data: function data() {
    return {
      year: year
    };
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_main__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_scss_main_scss__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_scss_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_scss_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_Header__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_Footer__ = __webpack_require__(56);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






//  Global Components




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-header', __WEBPACK_IMPORTED_MODULE_5__components_layout_Header__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-footer', __WEBPACK_IMPORTED_MODULE_6__components_layout_Footer__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd60bbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd60bbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SourcesList__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Sources__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Headlines__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Favorites__ = __webpack_require__(44);


//  HomePage

//  List of all Sources Page

//  Headlines from selected Sources Page

// Headlines from selected country

//  Favorites headlines


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/sources-list',
    name: 'sources-list',
    component: __WEBPACK_IMPORTED_MODULE_3__components_SourcesList__["a" /* default */]
  }, {
    path: '/headlines',
    name: 'headlines',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Headlines__["a" /* default */]
  }, {
    path: '/headlines/:country',
    name: 'headlines-country',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Headlines__["a" /* default */]
  }, {
    path: '/sources/:id',
    name: 'sources-id',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Sources__["a" /* default */]
  }, {
    path: '/favorites',
    name: 'favorites',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Favorites__["a" /* default */]
  }]
}));

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef8fd59_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(33);
function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ef8fd59"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef8fd59_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('app-header'),_vm._v(" "),_c('main',[_c('section',{staticClass:"uk-section uk-section-muted uk-margin-small-top uk-box-shadow-small uk-padding-small"},[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"uk-slider":"center: true"}},[_c('div',{staticClass:"uk-position-relative uk-visible-toggle uk-dark"},[_c('ul',{staticClass:"uk-slider-items uk-child-width-1-3@s uk-grid-medium uk-grid-margin",attrs:{"uk-grid":"","uk-height-match":"target: > li > div > .uk-card"}},[(_vm.allHeadlines.length === 0)?_c('li'):_vm._e(),_vm._v(" "),_vm._l((_vm.allHeadlines),function(hd){return _c('li',[_c('div',[_c('div',{staticClass:"uk-card uk-card-default uk-card-hover source-wrapper"},[_c('div',{staticClass:"uk-card-media-top"},[_c('img',{staticClass:"uk-responsive-width",attrs:{"src":hd.urlToImage,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"uk-card-body"},[_c('h3',{staticClass:"uk-card-title uk-text-truncate"},[_vm._v(" "+_vm._s(hd.title))]),_vm._v(" "),_c('p',{staticClass:"uk-text-break"},[_vm._v(" "+_vm._s(hd.description))])]),_vm._v(" "),_c('div',{staticClass:"uk-card-footer"},[_c('a',{attrs:{"href":hd.url,"target":"_blank"}},[_vm._v("Open...")]),_vm._v(" "),_c('button',{staticClass:"uk-button uk-button-secondary uk-align-right",on:{"click":function($event){_vm.addToFavorites(hd)}}},[_vm._v("Save\n                    ")])])])])])})],2),_vm._v(" "),_c('a',{staticClass:"uk-position-center-left uk-position-small uk-hidden-hover uk-slidenav-large",attrs:{"href":"#","uk-slidenav-previous":"","uk-slider-item":"previous"}}),_vm._v(" "),_c('a',{staticClass:"uk-position-center-right uk-position-small uk-hidden-hover uk-slidenav-large uk-dar",attrs:{"href":"#","uk-slidenav-next":"","uk-slider-item":"next"}})]),_vm._v(" "),_c('ul',{staticClass:"uk-slider-nav uk-dotnav uk-flex-center uk-margin"})]),_vm._v(" "),_c('div',{staticClass:"uk-text-right"},[_c('router-link',{attrs:{"to":{name:'headlines-country',params:{country:'us'}}}},[_c('button',{staticClass:"uk-button uk-button-default"},[_vm._v("View All Headlines")])])],1)])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"uk-heading-primary uk-heading-line uk-text-center"},[_c('span',[_vm._v("Top Headlines")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SourcesList_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_053fcae4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SourcesList_vue__ = __webpack_require__(36);
function injectStyle (ssrContext) {
  __webpack_require__(35)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-053fcae4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SourcesList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_053fcae4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SourcesList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('app-header'),_vm._v(" "),_c('main',[_c('article',[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"uk-text-center"},[_vm._v("\n        Browse through the existing list on News Headlines sources\n      ")]),_vm._v(" "),_c('div',{staticClass:"uk-text-center"},[_c('form',{staticClass:"uk-search uk-search-large"},[_c('span',{attrs:{"uk-search-icon":""}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"uk-search-input",attrs:{"type":"search","placeholder":"Search..."},domProps:{"value":(_vm.searchTerm)},on:{"keyup":function($event){_vm.searchThrough(_vm.searchTerm)},"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}})])]),_vm._v(" "),_c('section',{staticClass:"uk-section uk-section-default"},[_c('div',{staticClass:"uk-flex-1 uk-child-width-1-3@m uk-child-width-1-1@s uk-grid-medium uk-flex-center uk-grid-margin",attrs:{"uk-grid":"","uk-height-match":"target: > div > .uk-card"}},[(_vm.sources.length === 0)?_c('div',{}):_vm._e(),_vm._v(" "),_vm._l((_vm.filterSources),function(source){return _c('div',[_c('div',{staticClass:"uk-card uk-card-default source-wrapper"},[_c('div',{staticClass:"uk-card-header"},[_c('h3',{staticClass:"uk-text-center uk-card-title"},[_vm._v(_vm._s(source.name))])]),_vm._v(" "),_c('div',{staticClass:"uk-card-body"},[_c('span',{staticClass:"uk-card-badge uk-label uk-visible@s"},[_vm._v(_vm._s(source.country))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(source.description))])]),_vm._v(" "),_c('div',{staticClass:"uk-card-footer"},[_c('router-link',{attrs:{"to":{name:'sources-id',params:{id:source.id}}}},[_vm._v("View headlines")])],1)])])})],2)])])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"uk-heading-line uk-text-center"},[_c('span',[_vm._v("All News Sources")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sources_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efd8002e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sources_vue__ = __webpack_require__(39);
function injectStyle (ssrContext) {
  __webpack_require__(38)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-efd8002e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sources_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efd8002e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sources_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('app-header'),_vm._v(" "),_c('main',[_c('h2',{staticClass:"uk-text-center uk-heading-line"},[(_vm.headlines.length > 0)?_c('span',[_vm._v("Headlines from "+_vm._s(_vm.headlines[0].source.name))]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"uk-section uk-section-default"},[_c('div',{staticClass:"uk-flex-1 uk-child-width-1-3@m uk-child-width-1-1\\@s uk-grid-medium uk-flex-center uk-grid-margin",attrs:{"uk-grid":"","uk-height-match":"target: > div > .uk-card"}},[(_vm.headlines.length === 0)?_c('div',{}):_vm._e(),_vm._v(" "),_vm._l((_vm.headlines),function(headline){return _c('div',[_c('div',{staticClass:"uk-card uk-card-default source-wrapper"},[_c('div',{staticClass:"uk-card-media-top"},[_c('img',{staticClass:"uk-responsive-width",attrs:{"src":headline.urlToImage,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"uk-card-body"},[_c('h3',{staticClass:"uk-card-title uk-text-truncate"},[_vm._v(" "+_vm._s(headline.title))]),_vm._v(" "),_c('p',{staticClass:"uk-text-break"},[_vm._v(" "+_vm._s(headline.description))])]),_vm._v(" "),_c('div',{staticClass:"uk-card-footer"},[_c('a',{attrs:{"href":headline.url,"target":"_blank"}},[_vm._v("Read More...")]),_vm._v(" "),_c('button',{staticClass:"uk-button uk-button-secondary uk-align-right",on:{"click":function($event){_vm.addToFavorites(headline)}}},[_vm._v("Save\n              ")])])])])})],2)])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Headlines_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd04832_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Headlines_vue__ = __webpack_require__(43);
function injectStyle (ssrContext) {
  __webpack_require__(41)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fd04832"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Headlines_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd04832_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Headlines_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = ["ae","ar","at","au","be","bg","br","ca","ch","cn","co","cu","cz","de","eg","fr","gb","gr","hk","hu","id","ie","il","in","it","jp","kr","lt","lv","ma","mx","my","ng","nl","no","nz","ph","pl","pt","ro","rs","ru","sa","se","sg","si","sk","th","tr","tw","ua","us","ve","za"]

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('app-header'),_vm._v(" "),_c('main',[_c('article',[_c('h2',{staticClass:"uk-text-center uk-heading-line uk-heading-primary"},[_c('span',[_vm._v("Headlines from "),_c('span',{staticClass:"uk-text-capitalize"},[_vm._v(_vm._s(_vm.country))])])]),_vm._v(" "),_c('div',[_c('form',{staticClass:"uk-text-right",attrs:{"action":""}},[_c('div',{staticClass:"uk-padding-small",attrs:{"uk-form-custom":"target: > * > span:first-child"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cntry),expression:"cntry"}],attrs:{"name":"countries","id":"countries"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cntry=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.ctry(_vm.cntry)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Country")]),_vm._v(" "),_vm._l((_vm.countries),function(country){return _c('option',{domProps:{"value":country}},[_vm._v(_vm._s(country))])})],2),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('section',{staticClass:"uk-section uk-section-default"},[_c('div',{staticClass:"uk-flex-1 uk-child-width-1-3@m uk-child-width-1-1\\@s uk-grid-medium uk-flex-center uk-grid-margin",attrs:{"uk-grid":"","uk-height-match":"target: > div > .uk-card"}},[(_vm.headlines.length === 0)?_c('div',{}):_vm._e(),_vm._v(" "),_vm._l((_vm.headlines),function(headline){return _c('div',[_c('div',{staticClass:"uk-card uk-card-default source-wrapper"},[_c('div',{staticClass:"uk-card-media-top"},[_c('img',{staticClass:"uk-responsive-width",attrs:{"src":headline.urlToImage,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"uk-card-body"},[_c('h3',{staticClass:"uk-card-title uk-text-truncate"},[_vm._v(" "+_vm._s(headline.title))]),_vm._v(" "),_c('p',{staticClass:"uk-text-break"},[_vm._v(" "+_vm._s(headline.description))])]),_vm._v(" "),_c('div',{staticClass:"uk-card-footer"},[_c('a',{attrs:{"href":headline.url,"target":"_blank"}},[_vm._v("Read More...")]),_vm._v(" "),_c('button',{staticClass:"uk-button uk-button-secondary uk-align-right",on:{"click":function($event){_vm.addToFavorites(headline)}}},[_vm._v("Save")])])])])})],2)])])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"uk-button uk-button-secondary",attrs:{"type":"button","tabindex":"-1"}},[_c('span'),_vm._v(" "),_c('span',{attrs:{"uk-icon":"icon: chevron-down"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Favorites_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1ad2950_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Favorites_vue__ = __webpack_require__(46);
function injectStyle (ssrContext) {
  __webpack_require__(45)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d1ad2950"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Favorites_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1ad2950_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Favorites_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('app-header'),_vm._v(" "),_c('main',[_c('article',[_vm._m(0),_vm._v(" "),_c('div',[_c('form',{staticClass:"uk-text-right",attrs:{"action":""}},[_c('div',{staticClass:"uk-padding-small",attrs:{"uk-form-custom":"target: > * > span:first-child"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sort),expression:"sort"}],attrs:{"name":"sort","id":"sort"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sort=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.sortBy(_vm.sort)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Sort By")]),_vm._v(" "),_c('option',{attrs:{"value":"source.name"}},[_vm._v("Source")]),_vm._v(" "),_c('option',{attrs:{"value":"author"}},[_vm._v("Author")])]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('section',{staticClass:"uk-section uk-section-default"},[_c('div',{staticClass:"uk-flex-1 uk-child-width-1-3@m uk-child-width-1-1\\@s uk-grid-medium uk-flex-center uk-grid-margin",attrs:{"uk-grid":"","uk-height-match":"target: > div > div > .uk-card"}},[(_vm.headlines.length === 0)?_c('div',{},[_c('p',[_vm._v("No Headlines Saved")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.headlines),function(headline){return _c('div',[_c('div',[_c('div',{staticClass:"uk-card uk-card-default source-wrapper"},[_c('div',{staticClass:"uk-card-media-top"},[_c('img',{staticClass:"uk-responsive-width",attrs:{"src":headline.urlToImage,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"uk-card-body"},[_c('span',{staticClass:"uk-card-badge uk-label"},[_vm._v(_vm._s(headline.source.name))]),_vm._v(" "),_c('h3',{staticClass:"uk-card-title uk-text-truncate"},[_vm._v(" "+_vm._s(headline.title))]),_vm._v(" "),_c('p',{staticClass:"uk-text-break"},[_vm._v(" "+_vm._s(headline.description))])]),_vm._v(" "),_c('div',{staticClass:"uk-card-footer"},[_c('a',{attrs:{"href":headline.url,"target":"_blank"}},[_vm._v("Read More...")])])])])])})],2)])])]),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"uk-text-center uk-heading-line uk-heading-primary"},[_c('span',[_vm._v("Saved Headlines")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"uk-button uk-button-secondary",attrs:{"type":"button","tabindex":"-1"}},[_c('span'),_vm._v(" "),_c('span',{attrs:{"uk-icon":"icon: chevron-down"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uikit__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uikit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uikit_dist_js_uikit_icons__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uikit_dist_js_uikit_icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uikit_dist_js_uikit_icons__);



window.UIkit = __webpack_require__(13);

__WEBPACK_IMPORTED_MODULE_0_uikit___default.a.use(__WEBPACK_IMPORTED_MODULE_1_uikit_dist_js_uikit_icons___default.a);

// const updateReady = (sw) => {
//   UIkit
//     .modal
//     .confirm('New Version Available')
//     .then(() => {
//       //  Accept
//       sw.postMessage({
//         action: 'skipWaiting',
//       });
//     }, () => {
//       //  Reject
//     });
// };
//
// const trackInstalling = (sw) => {
//   sw.addEventListener('statechange', () => {
//     if (sw.state === 'installed') {
//       return updateReady(sw);
//     }
//     return this;
//   });
// };

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/service-worker.js', {
//     scope: '/',
//   }).then((sw) => {
//     if (sw.waiting) {
//       updateReady(sw.waiting);
//       return;
//     }
//     if (sw.installing) {
//       trackInstalling(sw.installing);
//       return;
//     }
//     sw.addEventListener('updatefound', () => {
//       trackInstalling(sw.installing);
//     });
//   }).catch(() => {
//     // console.log('fail', error);
//   });
//   navigator.serviceWorker.addEventListener('controllerchange', () => {
//     window.location.reload();
//   });
// }

/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96d86382_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(55);
function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-96d86382"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96d86382_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cc4872c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__ = __webpack_require__(54);
function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cc4872c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cc4872c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"uk-navbar-container uk-margin uk-flex",attrs:{"uk-navbar":""}},[_c('div',{staticClass:"uk-navbar-left"},[_c('router-link',{staticClass:"uk-navbar-item uk-logo uk-visible@m",attrs:{"to":{name:'home'}}},[_vm._v("Headlines")])],1),_vm._v(" "),_c('div',{staticClass:"uk-navbar-right"},[_c('ul',{staticClass:"uk-navbar-nav"},[_c('li',[_c('router-link',{attrs:{"to":{name:'home'}}},[_vm._v("\n          Home\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name:'sources-list'}}},[_vm._v("\n          Sources\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name:'favorites'}}},[_vm._v("\n          Favorites\n        ")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"uk-sticky":"sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky"}},[_c('app-nav')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a543f76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(58);
function injectStyle (ssrContext) {
  __webpack_require__(57)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a543f76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a543f76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"uk-section uk-section-secondary uk-padding-small uk-margin-remove"},[_c('p',[_vm._v("Headlines App")]),_vm._v(" "),_c('small',{staticClass:"uk-text-muted"},[_vm._v("\n      "+_vm._s(_vm.year)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[17]);


// WEBPACK FOOTER //
// static/js/app.2a2c3d2688150690f284.js